/** De melding dat er een nieuwe versie van de app klaarstaat (`UpdateNotice`). */
export const updateNoticeCopy = {
    text: 'Er staat een nieuwe versie van Smartkeur klaar.',
    action: 'Vernieuwen',
} as const;
